import * as i0 from '@angular/core';
import { ViewContainerRef, Component, ViewEncapsulation, ChangeDetectionStrategy, ViewChild, Input, Injectable } from '@angular/core';
import * as i4 from '@ng-dot/core';
import { DotParagraphPipe } from '@ng-dot/core';
import * as i1 from '@ng-dot/ui/ci24';
import { DotCi24Module } from '@ng-dot/ui/ci24';
import { DotFrameModule } from '@ng-dot/ui/frame';
import * as i2 from '@ng-dot/ui/link';
import { DotLinkModule } from '@ng-dot/ui/link';
import * as i3 from '@ng-dot/ux/dock';
const _c0 = ["viewContainerRef"];
const _c1 = ["*"];
function DotBannerFrameComponent_ng_template_1_Template(rf, ctx) {}
const _c2 = ["marker"];
function DotBannerPoolComponent_ng_template_0_Template(rf, ctx) {}
class DotBannerFrameComponent {
  _banner;
  viewContainerRef;
  constructor(_banner) {
    this._banner = _banner;
  }
  ngAfterViewInit() {
    this._banner.addFrame(this);
  }
  static ɵfac = function DotBannerFrameComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotBannerFrameComponent)(i0.ɵɵdirectiveInject(DotBannerService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotBannerFrameComponent,
    selectors: [["dot-banner-frame"]],
    viewQuery: function DotBannerFrameComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 7, ViewContainerRef);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.viewContainerRef = _t.first);
      }
    },
    hostAttrs: [1, "dot-banner-frame"],
    ngContentSelectors: _c1,
    decls: 5,
    vars: 0,
    consts: [["viewContainerRef", ""], [1, "dot-banners"], [1, "contents"]],
    template: function DotBannerFrameComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 1);
        i0.ɵɵtemplate(1, DotBannerFrameComponent_ng_template_1_Template, 0, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵprojection(4);
        i0.ɵɵelementEnd();
      }
    },
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotBannerFrameComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'dot-banner-frame',
      template: `
		<div class="dot-banners">
			<ng-template #viewContainerRef></ng-template>
		</div>
		<div class="contents">
			<ng-content></ng-content>
		</div>
	`,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        class: 'dot-banner-frame'
      }
    }]
  }], () => [{
    type: DotBannerService
  }], {
    viewContainerRef: [{
      type: ViewChild,
      args: ['viewContainerRef', {
        static: true,
        read: ViewContainerRef
      }]
    }]
  });
})();
class DotBannerPoolComponent {
  viewContainerRef;
  static ɵfac = function DotBannerPoolComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotBannerPoolComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotBannerPoolComponent,
    selectors: [["dot-banner-pool"]],
    viewQuery: function DotBannerPoolComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c2, 7, ViewContainerRef);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.viewContainerRef = _t.first);
      }
    },
    hostAttrs: [1, "dot-banner-pool"],
    decls: 2,
    vars: 0,
    consts: [["marker", ""]],
    template: function DotBannerPoolComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, DotBannerPoolComponent_ng_template_0_Template, 0, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
      }
    },
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotBannerPoolComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'dot-banner-pool',
      template: `
		<ng-template #marker></ng-template>
	`,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        class: 'dot-banner-pool'
      }
    }]
  }], null, {
    viewContainerRef: [{
      type: ViewChild,
      args: ['marker', {
        static: true,
        read: ViewContainerRef
      }]
    }]
  });
})();
class DotBannerComponent {
  componentRef;
  set option(option) {
    this._option = option;
    this._render();
  }
  _option;
  _host;
  constructor(elementRef) {
    this._host = elementRef.nativeElement;
  }
  _render() {
    const {
      background
    } = this._option;
    if (background) {
      this._host.style.backgroundColor = background;
    }
  }
  close() {
    const {
      _option
    } = this;
    if (_option.closeUntil) {
      localStorage.setItem('.banner:' + _option.id, '' + Date.now());
    }
    this.componentRef.destroy();
  }
  static ɵfac = function DotBannerComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotBannerComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotBannerComponent,
    selectors: [["ng-component"]],
    hostAttrs: [1, "dot-banner"],
    inputs: {
      componentRef: "componentRef",
      option: "option"
    },
    decls: 6,
    vars: 3,
    consts: [[1, "dot-banner-body", 3, "innerHTML"], ["dot-link", "", 3, "click"], ["type", "x"]],
    template: function DotBannerComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "article");
        i0.ɵɵelement(1, "div", 0);
        i0.ɵɵpipe(2, "paragraph");
        i0.ɵɵelementStart(3, "nav")(4, "button", 1);
        i0.ɵɵlistener("click", function DotBannerComponent_Template_button_click_4_listener() {
          return ctx.close();
        });
        i0.ɵɵelement(5, "dot-ci24", 2);
        i0.ɵɵelementEnd()()();
      }
      if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 1, ctx._option.content), i0.ɵɵsanitizeHtml);
      }
    },
    dependencies: [
    // DotNl2brPipe,
    DotCi24Module, i1.DotCi24Component, DotLinkModule, i2.DotLinkComponent, DotFrameModule, DotParagraphPipe],
    styles: [":root{--banner-backs: #000;--banner-react-backs: #222}.dot-banner{display:block;position:relative;color:#fff;background:var(--banner-backs);padding:20px;line-height:1.6}.dot-banner:hover{background:var(--banner-react-backs)}.dot-banner-pool{z-index:9999;left:0;right:0;transform:none;overflow:auto;max-height:100%}.dot-banner-pool:empty{display:none}.dot-banner-frame{display:flex;flex-direction:column;min-height:100%}.dot-banner article{display:flex}.dot-banner-body{flex-grow:1;overflow:auto}.dot-banner h1,.dot-banner h2,.dot-banner h3,.dot-banner h4,.dot-banner h5,.dot-banner h6{margin-bottom:.875em}.dot-banner p:not(:last-child){margin-bottom:3em}.dot-banner ul,.dot-banner ol{display:block;margin-block-start:1em;margin-block-end:1em;margin-inline-start:0;margin-inline-end:0;padding-inline-start:40px}.dot-banner ul{list-style-type:disc}.dot-banner ol{list-style-type:decimal}@supports (not (-webkit-hyphens: none)) and (not (-moz-appearance: none)) and (list-style-type: \"*\"){.dot-banner{--banner-backs: #2b2b2b;--banner-react-backs: #3a3a3a}.dot-banner:last-child{border-bottom-left-radius:8px;border-bottom-right-radius:8px;overflow:hidden}}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotBannerComponent, [{
    type: Component,
    args: [{
      template: `
		<article>
			<div class="dot-banner-body" [innerHTML]="_option.content | paragraph">
			</div>
			<nav>
				<button dot-link
						(click)="close()"
				>
					<dot-ci24 type="x"></dot-ci24>
				</button>
			</nav>
		</article>
	`,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [
      // DotNl2brPipe,
      DotCi24Module, DotLinkModule, DotFrameModule, DotParagraphPipe],
      host: {
        class: 'dot-banner'
      },
      styles: [":root{--banner-backs: #000;--banner-react-backs: #222}.dot-banner{display:block;position:relative;color:#fff;background:var(--banner-backs);padding:20px;line-height:1.6}.dot-banner:hover{background:var(--banner-react-backs)}.dot-banner-pool{z-index:9999;left:0;right:0;transform:none;overflow:auto;max-height:100%}.dot-banner-pool:empty{display:none}.dot-banner-frame{display:flex;flex-direction:column;min-height:100%}.dot-banner article{display:flex}.dot-banner-body{flex-grow:1;overflow:auto}.dot-banner h1,.dot-banner h2,.dot-banner h3,.dot-banner h4,.dot-banner h5,.dot-banner h6{margin-bottom:.875em}.dot-banner p:not(:last-child){margin-bottom:3em}.dot-banner ul,.dot-banner ol{display:block;margin-block-start:1em;margin-block-end:1em;margin-inline-start:0;margin-inline-end:0;padding-inline-start:40px}.dot-banner ul{list-style-type:disc}.dot-banner ol{list-style-type:decimal}@supports (not (-webkit-hyphens: none)) and (not (-moz-appearance: none)) and (list-style-type: \"*\"){.dot-banner{--banner-backs: #2b2b2b;--banner-react-backs: #3a3a3a}.dot-banner:last-child{border-bottom-left-radius:8px;border-bottom-right-radius:8px;overflow:hidden}}\n"]
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    componentRef: [{
      type: Input
    }],
    option: [{
      type: Input
    }]
  });
})();
class DotBannerService {
  _dock;
  _component;
  frame;
  _options = [];
  pool;
  constructor(_dock, _component) {
    this._dock = _dock;
    this._component = _component;
    this.pool = this._dock.add('top', DotBannerPoolComponent, DotBannerComponent);
  }
  addFrame(frame) {
    const previousFrame = this.frame;
    this.frame = frame;
    if (!previousFrame) {
      const {
        _options
      } = this;
      const end = _options.length;
      let current = -1;
      while (++current < end) {
        this.open(_options[current]);
      }
      this._options = [];
    }
  }
  open(option) {
    const {
      frame,
      pool
    } = this;
    if (!frame && !pool) {
      this._options[this._options.length] = option;
      return;
    }
    option = {
      closeUntil: 86400,
      ...option
    };
    const {
      closeUntil
    } = option;
    if (closeUntil) {
      const id = '.banner:' + option.id;
      const closed = localStorage.getItem(id);
      if (closed && Date.now() < +closed + option.closeUntil * 1000) {
        return;
      }
    }
    if (frame) {
      this._component.append(this.frame.viewContainerRef, DotBannerComponent, {
        option
      });
    } else {
      pool.append({
        option
      });
    }
  }
  static ɵfac = function DotBannerService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotBannerService)(i0.ɵɵinject(i3.DotDockService), i0.ɵɵinject(i4.DotComponentService));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DotBannerService,
    factory: DotBannerService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotBannerService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i3.DotDockService
  }, {
    type: i4.DotComponentService
  }], null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { DotBannerComponent, DotBannerFrameComponent, DotBannerPoolComponent, DotBannerService };
